import { useState, useEffect } from 'react';
import { sendSmsLink, verifySmsLink, getStoredPhone, clearStoredPhone } from '../services/authService';
import { getErrorMessage } from '../utils/errors';

interface UseSmsAuthReturn {
  sendLink: (phoneNumber: string) => Promise<void>;
  verifyLink: (token: string) => Promise<void>;
  loading: boolean;
  loadingMessage: string | null;
  error: string | null;
  linkSent: boolean;
  storedPhone: string | null;
  clearError: () => void;
}

export const useSmsAuth = (): UseSmsAuthReturn => {
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingMessage, setLoadingMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [linkSent, setLinkSent] = useState<boolean>(false);
  const [storedPhone, setStoredPhone] = useState<string | null>(null);

  useEffect(() => {
    const phone = getStoredPhone();
    setStoredPhone(phone);
  }, []);

  const clearError = (): void => {
    setError(null);
  };

  const sendLink = async (phoneNumber: string): Promise<void> => {
    setLoading(true);
    setError(null);
    setLoadingMessage('Invio SMS...');

    try {
      await sendSmsLink(phoneNumber);
      setLinkSent(true);
      setStoredPhone(phoneNumber);
      setLoadingMessage(null);
    } catch (err) {
      setError(getErrorMessage(err));
      setLinkSent(false);
      setLoadingMessage(null);
    } finally {
      setLoading(false);
    }
  };

  const verifyLink = async (token: string): Promise<void> => {
    setLoading(true);
    setError(null);
    setLoadingMessage('Verifica in corso...');

    try {
      await verifySmsLink(token);
      setLinkSent(false);
      setStoredPhone(null);
      clearStoredPhone();
      setLoadingMessage(null);
    } catch (err) {
      setError(getErrorMessage(err));
      setLoadingMessage(null);
    } finally {
      setLoading(false);
    }
  };

  return {
    sendLink,
    verifyLink,
    loading,
    loadingMessage,
    error,
    linkSent,
    storedPhone,
    clearError,
  };
};
